import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';

@Injectable()
export class ActionsCompletedPluginService extends InspectionPluginService {
  constructor(protected apiService: ApiService, protected dataService: DataService, private inspectionFactory: InspectionFactoryService) {
    super(apiService, dataService, null, inspectionFactory);
  }

  public updateActions(inspectionId: string, pointId: string, pluginId: string, actions: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, actions).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public deletePlugin(inspectionId: string, pointId: string, pluginId: string) {
    return super.deletePlugin(inspectionId, pointId, pluginId).pipe(
      map((success) => {
        return success;
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, actions: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, actions, 'Actions').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
